import { Typography } from 'primsell-shared-layer/components'

import * as S from './timer-container.styles'

export interface ITimerContainerProps {
  leftString: string
  rightString?: string
  warning?: boolean
}

const TimerContainer = ({ leftString, rightString, warning }: ITimerContainerProps): JSX.Element | null => {
  return (
    <S.ExpPaymentTimerBox center={!rightString}>
      <S.ExpPaymentTimerContainerLeft>
        <Typography>{leftString}</Typography>
      </S.ExpPaymentTimerContainerLeft>
      {!!rightString && (
        <S.ExpPaymentTimerContainerRight>
          <S.ExpPaymentTimer warning={warning}>{rightString}</S.ExpPaymentTimer>
        </S.ExpPaymentTimerContainerRight>
      )}
    </S.ExpPaymentTimerBox>
  )
}

export { TimerContainer }
